import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configure Web Vitals monitoring
// Log performance metrics to console in development
// In production, send to your analytics endpoint
reportWebVitals((metric) => {
  // Log to console in development
  console.log(metric);

  // In production, you can send to an analytics service like:
  // - Google Analytics
  // - Your own analytics endpoint
  // Example:
  // if (process.env.NODE_ENV === 'production') {
  //   fetch('/api/analytics', {
  //     method: 'POST',
  //     body: JSON.stringify(metric),
  //     headers: { 'Content-Type': 'application/json' }
  //   });
  // }
});
